// Viewport
if(navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('iPod') > 0 || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0)){
  $('head').prepend('<meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1, minimum-scale=1, maximum-scale=1, viewport-fit=cover">');
}else if(navigator.userAgent.indexOf('iPad') > 0 || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') == -1) || navigator.userAgent.indexOf('A1_07') > 0 || navigator.userAgent.indexOf('SC-01C') > 0){
  $('head').prepend('<meta name="viewport" content="width=1280px">');
}

$(document).ready(function(){
  //Scroll
  var href, target, position;
  $('a[href^="#"]').click(function(){
    href= $(this).attr('href');
    target = $(href == "#" || href == "" ? 'html' : href);
    position = target.offset().top;
    $('html, body').animate({scrollTop:position}, 600, 'easeInOutQuart');
    return false;
  });

  //Swiper
  var swiperThumbs1, swiperTop1;
  swiperThumbs1 = new Swiper('.way-case-swiperthumbs-1', {
    spaceBetween: 8,
    slidesPerView: 5,
    freeMode: true,
    navigation: {
      prevEl: '.way-case-swiperthumbs-prev-1',
      nextEl: '.way-case-swiperthumbs-next-1'
    }
  });
  swiperTop1 = new Swiper('.way-case-swipertop-1', {
    autoHeight: true,
    centeredSlides: true,
    slidesPerView: 1,
    speed: 600,
    thumbs: {
      swiper: swiperThumbs1
    }
  });
  var swiperThumbs2, swiperTop2;
  swiperThumbs2 = new Swiper('.way-case-swiperthumbs-2', {
    spaceBetween: 8,
    slidesPerView: 5,
    freeMode: true,
    navigation: {
      prevEl: '.way-case-swiperthumbs-prev-2',
      nextEl: '.way-case-swiperthumbs-next-2'
    }
  });
  swiperTop2 = new Swiper('.way-case-swipertop-2', {
    autoHeight: true,
    centeredSlides: true,
    slidesPerView: 1,
    speed: 600,
    thumbs: {
      swiper: swiperThumbs2
    }
  });
  var swiperThumbs3, swiperTop3;
  swiperThumbs3 = new Swiper('.way-case-swiperthumbs-3', {
    spaceBetween: 8,
    slidesPerView: 5,
    freeMode: true,
    navigation: {
      prevEl: '.way-case-swiperthumbs-prev-3',
      nextEl: '.way-case-swiperthumbs-next-3'
    }
  });
  swiperTop3 = new Swiper('.way-case-swipertop-3', {
    autoHeight: true,
    centeredSlides: true,
    slidesPerView: 1,
    speed: 600,
    thumbs: {
      swiper: swiperThumbs3
    }
  });
  var swiperThumbs4, swiperTop4;
  swiperThumbs4 = new Swiper('.way-case-swiperthumbs-4', {
    spaceBetween: 8,
    slidesPerView: 5,
    freeMode: true,
    navigation: {
      prevEl: '.way-case-swiperthumbs-prev-4',
      nextEl: '.way-case-swiperthumbs-next-4'
    }
  });
  swiperTop4 = new Swiper('.way-case-swipertop-4', {
    autoHeight: true,
    centeredSlides: true,
    slidesPerView: 1,
    speed: 600,
    thumbs: {
      swiper: swiperThumbs4
    }
  });
  var swiperThumbs5, swiperTop5;
  swiperThumbs5 = new Swiper('.way-case-swiperthumbs-5', {
    spaceBetween: 8,
    slidesPerView: 5,
    freeMode: true,
    navigation: {
      prevEl: '.way-case-swiperthumbs-prev-5',
      nextEl: '.way-case-swiperthumbs-next-5'
    }
  });
  swiperTop5 = new Swiper('.way-case-swipertop-5', {
    autoHeight: true,
    centeredSlides: true,
    slidesPerView: 1,
    speed: 600,
    thumbs: {
      swiper: swiperThumbs5
    }
  });

  //Fluidbox
  $('a[data-fluidbox]').fluidbox();

  //FAQ Toggle
  $('.faq-content-dl-dt').on('click', function(){
    $(this).toggleClass('active');
    $(this).next().slideToggle(300, 'easeInOutQuart');
  });

  //Form
  var errorEl, errorPosi;
  $('[name="zip"]').on('keyup', function (){
		AjaxZip3.zip2addr(this,'','address','address');
	});
  if($('.error')[0]){
    $('.mw_wp_form').addClass('mw_wp_form_error');
    errorEl = $('.mw_wp_form').eq(0);
    errorPosi = errorEl.parent().offset().top - 100;
    $('html, body').delay(90).animate({scrollTop:errorPosi}, 600, 'easeInOutQuart');
  }
});

$(window).on('load', function(){
  //Inview
  $('#form').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){ $('#footer-a').addClass('anima');}
    else{ $('#footer-a').removeClass('anima');}
  });
});
